import { GrantsType, hasScopedPermission } from '../../../Shared/utils/auth';

export const editPolicyCoveragePermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'coverages.edit_policy_coverages');

export const editVehicleCoveragePermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'coverages.edit_vehicle_coverages');

export const editCoveragesRequiringSignaturesPermissionsPolicy = (
  grants: GrantsType
) =>
  hasScopedPermission(
    grants,
    'partner',
    'coverages.edit_coverages_requiring_signatures'
  );
